import { Either } from "fp-ts/lib/Either";
import ShiftEntity from "../entities/ShiftEntity";
import { UserType } from "../entities/UserEntity";
import ErrorEntity from "../entities/ErrorEntity";


export interface GetUserReportResponse {
    workedHours: number;
    assistedShifts: number;
    missedShifts: number;
    pendingShifts: number;
    shifts: ShiftEntity[];
}
export default interface ReportRepository {
    getUserReport(_:{
        userId: String,
        role: UserType,
        startDate: Date,
        endDate: Date,
    }): Promise<Either<ErrorEntity, GetUserReportResponse>>
}

export const ReportRepositoryName = "ReportRepository";